<script lang="ts">
  interface Props {
    bg?: string;
    error?: boolean;
    class?: string;
    children?: import("svelte").Snippet;
  }

  let { bg = "bg-Neutral110", error = false, class: className, children }: Props = $props();
</script>

<div
  class="{bg} {error
    ? 'border-2 border-Red900'
    : 'border border-Neutral300'} p-4 {className} mb-3 -mx-3 md:-mx-0"
>
  {@render children?.()}
</div>
